
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legacy",
      function () {
        return require("private-next-pages/legacy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legacy"])
      });
    }
  